/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconUsersGroup = createReactComponent("users-group", "IconUsersGroup", [
  ["path", { d: "M10 13a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", key: "svg-0" }],
  ["path", { d: "M8 21v-1a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v1", key: "svg-1" }],
  ["path", { d: "M15 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", key: "svg-2" }],
  ["path", { d: "M17 10h2a2 2 0 0 1 2 2v1", key: "svg-3" }],
  ["path", { d: "M5 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", key: "svg-4" }],
  ["path", { d: "M3 13v-1a2 2 0 0 1 2 -2h2", key: "svg-5" }]
]);

export { IconUsersGroup as default };
//# sourceMappingURL=IconUsersGroup.js.map
